export const approuveDefinitions = [
    {
        "descr": "Non approuvé français",
        "abreg": "non_appr_web",
        "idx": 1
    },
    {
        "descr": "Non approuvé anglais",
        "abreg": "non_appr_web_angl",
        "idx": 2
    },
    {
        "descr": "Approuvé français",
        "abreg": "appr_web",
        "idx": 3
    },
    {
        "descr": "Approuvé anglais",
        "abreg": "appr_web_angl",
        "idx": 4
    }
];